import React from 'react';

import { ReaderLayout } from '../';
import {
  AnalyticsProvider,
  BookAppearanceProvider,
  BookLocationProvider,
  BookProvider,
  CollaborationProvider,
  DeviceInfoProvider,
  DocumentProvider,
  DRMProvider,
  PrintProvider,
  OfflineProvider,
  ReaderSettingsProvider,
  TextToSpeechProvider,
  UserContentItemProvider,
  UserContentProvider,
  UserSessionProvider,
} from 'providers';
import { setupCrashDetection } from 'utilities/crashDetection';

const App = () => {
  window.v7 = window.v7 || {};

  setupCrashDetection();

  return (
    <DeviceInfoProvider>
      <BookProvider>
        <UserSessionProvider>
          <AnalyticsProvider>
            <DocumentProvider debug={true}>
              <BookLocationProvider>
                <BookAppearanceProvider>
                  <ReaderSettingsProvider>
                    <UserContentProvider>
                      <UserContentItemProvider>
                        <DRMProvider>
                          <OfflineProvider>
                            <CollaborationProvider>
                              <PrintProvider>
                                <TextToSpeechProvider>
                                  <ReaderLayout />
                                </TextToSpeechProvider>
                              </PrintProvider>
                            </CollaborationProvider>
                          </OfflineProvider>
                        </DRMProvider>
                      </UserContentItemProvider>
                    </UserContentProvider>
                  </ReaderSettingsProvider>
                </BookAppearanceProvider>
              </BookLocationProvider>
            </DocumentProvider>
          </AnalyticsProvider>
        </UserSessionProvider>
      </BookProvider>
    </DeviceInfoProvider>
  );
};

export default App;
